var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.showLoginPage()}}},[_vm._v("登陆/注册")])])
}
var staticRenderFns = []

export { render, staticRenderFns }